import { render, staticRenderFns } from "./AOptionalDatepicker.reg.vue?vue&type=template&id=188a0c16&"
import script from "./AOptionalDatepicker.reg.vue?vue&type=script&lang=ts&"
export * from "./AOptionalDatepicker.reg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
